export default __webpack_public_path__ + "static/media/material.21738153.pdf";